<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 40">
  <path d="M15.808 18.395c4.43.093 7.723-3.169 8.14-7.675.503-5.44-2.66-9.9-7.893-9.923C11.628.777 8.29 4.315 8.023 8.83c-.316 5.335 2.642 9.457 7.785 9.565Zm16.088 12.373c-3.453 5.087-9.285 8.429-15.897 8.429S3.555 35.854.102 30.766a8.93 8.93 0 0 1 8.825-7.569H23.07a8.93 8.93 0 0 1 8.825 7.57Z" fill="currentColor"/>
</svg>
